module.exports = __webpack_public_path__ + "img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.1f8c8f61.png";